import store from "@/config/vuex/store";

export default[
    {
        path: "/permissoes",
        component: () => import('@/pages/Layout/DashboardLayout'),
        children: [
            {
                path: "cadastrar",
                name: "permissaoCreate",
                component: () => import('@/pages/Permissao/PermissaoCreate'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }, 
            {
                path: "editar/:id",
                name: "permissaoUpdate",
                component: () => import('@/pages/Permissao/PermissaoUpdate'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "/",
                name: "permissaoRead",
                component: () => import('@/pages/Permissao/PermissaoRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }
        ]
    }
]
